import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import { IIndirectTaxFilingV2PrepaymentListResponse } from './types';

export function useIndirectTaxFilingV2Prepayments(
  filingId: string | null | undefined,
  corporationId: number | null | undefined,
  options?: { enabled?: boolean }
) {
  const enabled = options?.enabled ?? true;

  const key =
    enabled && filingId && corporationId
      ? `new-sales-tax/filings-v2/${filingId}/prepayments?corporationId=${corporationId}`
      : null;

  const { data, error, isLoading, mutate } =
    useSWR<IIndirectTaxFilingV2PrepaymentListResponse>(
      key,
      SWRFetcher({ method: 'GET' })
    );

  return {
    prepayments: data?.prepayments ?? [],
    count: data?.count ?? 0,
    globalizationPending: data?.globalizationPending ?? false,
    isLoading,
    error,
    mutate,
  };
}
